import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Block } from '../types/api.v2.types';

export interface BlockState {
  block: Block | null;
}

const initialState: BlockState = {
  block: null,
};

const blockSlice = createSlice({
  name: 'block',
  initialState,
  reducers: {
    setBlock(state, action: PayloadAction<Block>) {
      state.block = action.payload;
    },
  },
});

export const { setBlock } = blockSlice.actions;

export default blockSlice.reducer;
